import { useState } from 'react';
import { Link } from 'react-router-dom';
import { comments } from '@/mocks/comments';

export default function CommentSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const displayedComments = comments.slice(0, 4);

  return (
    <section className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="absolute top-0 left-0 opacity-[0.03] pointer-events-none">
        <svg width="200" height="400" viewBox="0 0 200 400" fill="none">
          <path d="M20 0C20 0 80 50 50 120C20 190 100 180 130 240C160 300 100 350 100 400" stroke="currentColor" strokeWidth="1.5" className="text-foreground-950" />
          <path d="M60 0C60 0 120 40 90 130C60 220 140 200 170 260C200 320 130 370 130 400" stroke="currentColor" strokeWidth="1" className="text-foreground-950" opacity="0.6" />
        </svg>
      </div>

      <div className="w-full px-4 md:px-6 relative z-10">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-10">
            <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950">
              瓜友<span className="text-primary-500">热评</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">吃瓜群众的真实声音，每一条都是态度</p>
          </div>

          <div className="flex flex-col lg:flex-row gap-6">
            <div className="lg:w-2/3">
              {displayedComments.map((comment, idx) => (
                <div
                  key={comment.id}
                  className={`rounded-2xl overflow-hidden transition-all duration-500 ${
                    idx === activeIndex ? 'opacity-100' : 'hidden'
                  }`}
                >
                  <div className="flex flex-col sm:flex-row bg-foreground-950">
                    <div className="sm:w-[35%] relative">
                      <img
                        src={comment.avatarUrl}
                        alt={comment.author}
                        className="w-full h-[250px] sm:h-full object-cover object-top"
                      />
                    </div>
                    <div className="sm:w-[65%] flex flex-col justify-center p-6 md:p-10">
                      <span className="text-6xl font-heading text-primary-400/30 leading-none mb-4">
                        &ldquo;
                      </span>
                      <blockquote className="text-base md:text-lg text-background-50 leading-relaxed mb-6">
                        {comment.content}
                      </blockquote>
                      <div className="mb-6">
                        <p className="text-sm font-medium text-background-50">{comment.author}</p>
                        <p className="text-xs text-foreground-400 mt-1">{comment.level} · {comment.publishDate}</p>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="flex items-center gap-1 text-xs text-primary-400">
                          <i className="ri-heart-fill" />
                          {comment.likes}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="lg:w-1/3 flex flex-col gap-3">
              {displayedComments.map((comment, idx) => (
                <button
                  key={comment.id}
                  onClick={() => setActiveIndex(idx)}
                  className={`text-left p-4 rounded-xl transition-all cursor-pointer whitespace-normal ${
                    idx === activeIndex
                      ? 'bg-primary-100/70 border border-primary-200'
                      : 'bg-background-100 border border-background-200 hover:border-background-300/60'
                  }`}
                >
                  <p className="text-sm font-medium text-foreground-900 line-clamp-2 mb-2">
                    {comment.content.slice(0, 50)}...
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{comment.author}</span>
                    <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-800 rounded-full whitespace-nowrap">
                      {comment.level}
                    </span>
                  </div>
                </button>
              ))}
              <Link
                to="/category/redianzonghe"
                className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap mt-2"
              >
                加入吃瓜讨论
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}